module.exports = __webpack_public_path__ + "img/logo.b8b7534d.jpg";